import React from 'react'
import { GenericPagination } from 'src/components/ui/pagination';

interface Props {
  pageSize: number;
  currentPageNumber: number;
  setSearchParams: (params: Record<string, string>) => void;
  searchParams: URLSearchParams;
  handleNextPage: () => void;
  handlePrevPage: () => void;
  handleJumpToPage: (page: number) => void;
  candidates: any[];
  exportCandidatesToExcel: (candidates: any[]) => void;
  copyAllEmails: () => void;
  handleDeleteSelected: () => void;
  deleting: boolean;
  selectedCandidates: Set<string>;
}

export const ActionFooter = ({ pageSize, currentPageNumber, setSearchParams, searchParams, handleNextPage, handlePrevPage, handleJumpToPage, candidates, exportCandidatesToExcel, copyAllEmails, handleDeleteSelected, deleting, selectedCandidates }: Props) => {
  return (
    <div className="flex justify-between items-center p-3 border rounded-md rounded-t-none">
      <div className="flex items-center justify-between px-3 py-2 border rounded-md border-sky-300">
        <label className="font-semibold">Limit</label>
        <select
          value={pageSize}
          onChange={(e) => {
            setSearchParams({
              ...Object.fromEntries(searchParams),
              pageSize: e.target.value,
              page: "1",
            });
          }}
          className="border p-1 rounded-md ml-2"
        >
          {[10, 25, 50, 100].map((value) => (
            <option key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
      </div>
      <div className="flex-grow">
        <GenericPagination
          currentPage={currentPageNumber}
          onNext={handleNextPage}
          onPrev={handlePrevPage}
          jumpPage={handleJumpToPage}
        />
      </div>
      <div className="join">
        <button
          className="btn btn-xs btn-outline sm:btn-sm md:btn-md join-item"
          onClick={() => exportCandidatesToExcel(candidates)}
          disabled={candidates.length === 0}
        >
          Get in Excel
        </button>
        <button
          className="btn btn-xs btn-outline sm:btn-sm md:btn-md join-item"
          onClick={copyAllEmails}
          disabled={candidates.length === 0}
        >
          Copy Emails
        </button>
        <button
          className="btn btn-xs btn-outline sm:btn-sm md:btn-md join-item"
          onClick={handleDeleteSelected}
          disabled={deleting || selectedCandidates.size === 0}
        >
          {deleting ? (
            <span className="loading loading-dots loading-md"></span>
          ) : (
            `Delete Selected ${selectedCandidates.size > 0 ? `(${selectedCandidates.size})` : ""}`
          )}
        </button>
      </div>
    </div>
  );
}
